
<template>
  <div>
    <div v-if="loading">
      <vue-element-loading :active="true" :is-full-screen="true" />
    </div>
    <CCard v-if="!loading" style="margin-top: 20px">
      <CCardHeader>
        <h5><b>Add Game</b></h5>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol sm="12">
            <CRow>
              <CCol sm="12">
                <label>Game Name</label>

                <CInput
                  class="w-50"
                  type="text"
                  placeholder="Enter the Game Name"
                  v-model="name"
                />
              </CCol>
              <CCol sm="12">
                <label>Description</label>
                <textarea
                  class="form-control mb-3 w-50"
                  id="message"
                  name="Description"
                  rows="4"
                  v-model="decription"
                  placeholder="Enter description here..."
                ></textarea>
              </CCol>

              <CCol sm="6" class="d-flex flex-column mb-3">
                <label>Cover Image</label>
                <input
                  type="file"
                  accept="image/*"
                  @change="uploadCoverImage"
                />
                <div id="preview" class="preview" v-if="coverImageUrl">
                  <img
                    v-if="coverImageUrl"
                    :src="coverImageUrl"
                    class="w-100"
                  />
                </div>
                <p v-if="isCoverImageUpload">
                  Progress: {{ CoverImageUploadValue.toFixed() + "%" }}
                  <progress
                    id="progress"
                    :value="CoverImageUploadValue"
                    max="100"
                  ></progress>
                </p>
              </CCol>
              <CCol sm="6" class="d-flex flex-column mb-3">
                <label>Thumbnail Image</label>
                <input type="file" accept="image/*" @change="uploadGameImage" />
                <div id="preview" class="preview" v-if="gameImageUrl">
                  <img v-if="gameImageUrl" :src="gameImageUrl" class="w-100" />
                </div>
                <p v-if="isGameImageUpload">
                  Progress: {{ gameImageUploadValue.toFixed() + "%" }}
                  <progress
                    id="progress"
                    :value="gameImageUploadValue"
                    max="100"
                  ></progress>
                </p>
              </CCol>

              <CCol sm="12" style="text-align: center !important">
                <CButton color="success" style="width: 20%" @click="saveGame()"
                  >Save</CButton
                >
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>
  
  <script>
import firebase from "firebase";
const db = firebase.firestore();
import VueElementLoading from "vue-element-loading";

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";
import { APIService } from "../../apiservice";
export default {
  components: { VueCtkDateTimePicker, VueElementLoading },
  data() {
    return {
      name: "",
      decription: "",
      coverImageUrl: null,
      CoverImageUploadValue: 0,
      gameImageUrl: null,
      gameImageUploadValue: 0,
      isGameImageUpload: false,
      isCoverImageUpload: false,
      loading: false,
    };
  },

  methods: {
    uploadGameImage(e) {
      this.gameImageUrl = null;
      this.gameImageUploadValue = 0;
      const file = e.target.files[0];
      this.isGameImageUpload = true;

      const storageRef = firebase
        .storage()
        .ref(
          `esportsCollections/gameImage/${new Date().toDateString()}/${new Date().toISOString()}`
        )
        .put(file);
      storageRef.on(
        "state_changed",
        (snapshot) => {
          this.gameImageUploadValue = parseInt(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
        },
        (error) => {
          this.isGameImageUpload = false;
          this.$swal("UpLoad Failed", "Try Again Later", "error");
        },
        () => {
          this.gameImageUploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.gameImageUrl = url;
            this.isGameImageUpload = false;
          });
        }
      );
    },
    uploadCoverImage(e) {
      this.coverImageUrl = null;
      this.CoverImageUploadValue = 0;
      const file = e.target.files[0];
      this.isCoverImageUpload = true;

      const storageRef = firebase
        .storage()
        .ref(
          `esportsCollections/coverImage/${new Date().toDateString()}/${new Date().toISOString()}`
        )
        .put(file);
      storageRef.on(
        "state_changed",
        (snapshot) => {
          this.CoverImageUploadValue = parseInt(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
        },
        (error) => {
          this.isCoverImageUpload = false;

          this.$swal("UpLoad Failed", "Try Again Later", "error");
        },
        () => {
          this.CoverImageUploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.coverImageUrl = url;
            this.isCoverImageUpload = false;
          });
        }
      );
    },
    GetgameName() {
      db.collection("esports")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            for (let i = 0; i < doc.data()["games"].length; i++) {
              this.options.push(doc.data()["games"][i].name);
            }
          });
        });
    },
    showMessage(msg, icon) {
      Swal.fire({
        position: "center",
        icon: icon,
        title: msg,
        showConfirmButton: false,
        timer: 3000,
      });
    },
    async saveGame() {
      var infoEnableTime = new Date(this.MatchStarttime);
      infoEnableTime.setMinutes(infoEnableTime.getMinutes() - 15);
      if (this.name == "") {
        this.showMessage("Please Enter the Game Name", "warning");
      } else if (this.decription == "") {
        this.showMessage("Please Enter the Description", "warning");
      } else if (this.coverImageUrl == null) {
        this.showMessage("Please Upload a Cover Image", "warning");
      } else if (this.gameImageUrl == null) {
        this.showMessage("Please Upload a Thumbnail Image", "warning");
      } else {
        let data = {
          gameName: this.name,
          description: this.decription,
          gameImage: this.gameImageUrl,
          coverImage: this.coverImageUrl,
        };
        try {
          this.loading = true;
          const response = await APIService.esportsGameUpdate(data);
          this.loading = false;
          if (response.status) {
            this.showMessage("Successfully Saved", "success");
            this.$router.push({
              name: "esportsList",
            });
          } else {
            this.showMessage(response.Message, "error");
          }
        } catch (error) {
          this.loading = false;
          this.showMessage("Something Went Wrong", "error");
        }
      }
    },
  },
  created() {},
};
</script>
  
  <style>
.preview {
  position: relative;
  margin-top: 20px;
  width: 250px;
  padding: 10px;

  /* border: 1px solid #000; */
  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px,
    rgba(0, 0, 0, 0.22) 0px 10px 10px;
}
</style>
  